<template>
  <div id="step-1" class="container-fluid">

    <Section title="Clinician's Details"
             text="Please complete the Clinician's details i.e. the details of the measuring nurse.">
      <Row>
        <Col class="col-12 col-sm-6 col-md-4">
          <TextInput name="clinician.name"
                     v-model="value.clinician.name"
                     label="Clinician's Name"
                     rules="required"
                     required=true
          />
        </Col>
        <Col class="col-12 col-sm-6 col-md-4">
          <TextInput name="clinician.phone"
                     v-model="value.clinician.phone"
                     label="Clinician's Phone"
                     type="number"
                     rules="required"
                     required=true
          />
        </Col>
        <Col class="col-12 col-sm-6 col-md-4">
          <TextInput name="clinician.email"
                     v-model="value.clinician.email"
                     label="Clinician's Email"
                     type="email" rules="email"
                     required=true
          />
        </Col>
      </Row>
    </Section>
    <hr>
    <Section title="Patient's Details">
      <Row class=" align-items-start">
        <Col class="col-12 col-sm-6 col-md-4">
          <TextInput name="patient.name.first"
                     v-model="value.patient.name.first"
                     label="Patient's First Name"
                     rules="required"
                     required=true
          />
        </Col>
        <Col class="col-12 col-sm-6 col-md-4">
          <TextInput name="patient.name.last"
                     v-model="value.patient.name.last"
                     label="Patient's Last Name"
                     rules="required"
                     required=true
          />
        </Col>
        <Col class="col-12 col-sm-6 col-md-4">
          <TextInput name="patient.nhsNumber"
                     v-model="value.patient.nhsNumber"
                     label="Patient's NHS Number"
                     type="number" rules="required"
                     required=true
          />
        </Col>
        <Col class="col-12 col-sm-6 col-md-4">
          <TextInput name="patient.phone"
                     v-model="value.patient.phone"
                     label="Patient's Phone"
                     type="number"
                     rules="required"
                     required=true
          />
        </Col>
        <Col class="col-12 col-sm-6 col-md-4">
          <TextInput name="patient.email"
                     v-model="value.patient.email"
                     label="Patient's Email"
                     type="email"
                     rules="email"
          />
        </Col>
        <Col class="col-auto">
          <RadioInput name="patient.deliverToPatient"
                      v-model="value.patient.deliverToPatient"
                      label="Deliver to patient address?"
                      :options="['No', 'Yes']"
                      rules="required"
                      required=true
          />
        </Col>
        <Col v-show="value.patient.deliverToPatient === 'Yes'" class="col-12">
          <AddressInput name="patient.address"
                        v-model="value.patient.address"
                        label="Patient's Address"
                        v-if="value.patient.deliverToPatient === 'Yes'"
                        required=true
          />
        </Col>
        <Col v-show="value.patient.deliverToPatient === 'No'" class="col-12">
          <AddressInput name="delivery.address"
                        v-model="value.delivery.address"
                        label="Alternate Delivery Address"
                        v-if="value.patient.deliverToPatient === 'No'"
                        required=true
          />
        </Col>
        <Col class="col-auto">
          <RadioInput name="patient.isExempt"
                      v-model="value.patient.isExempt"
                      label="Is Patient exempt?"
                      :options="['No', 'Yes']"
                      rules="required"
                      required=true
          />
        </Col>
        <Col v-show="value.patient.isExempt === 'No'" class="col-auto">
          <div class="alert alert-primary" role="alert">
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 11h2v5m-2 0h4m-2.592-8.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
            </svg>
            We will contact the patient the obtain payment using the details provided above.
          </div>
        </Col>
        <Col v-show="value.patient.isExempt === 'Yes'" class="col-auto align-content-start">
          <SelectInput name="patient.exemptionReason"
                       v-model="value.patient.exemptionReason"
                       label="Exemption Reason"
                       :options="exemptionReasons"
                       rules="required"
                       required=true
                       v-if="value.patient.isExempt === 'Yes'"
          />
        </Col>
      </Row>
    </Section>
    <hr>
    <Section title="Prescription Details"
             text="Please ensure you provide as many details about the products required as possible including:"
    >
      <p class="px-2" style="font-size:16px">MTM (Made-to-Measure) or RTW/OTS/Stock (Off-the-shelf), Brand, Range, Type (Below Knee, Thigh),<br/>
        Class, Colour, Size, Length, Width, Orientation &amp; Toe Style.</p>
      <ProductRepeater v-model="value.products"></ProductRepeater>

      <Row>
        <Col class="col-12 col-md-auto">
          <RadioInput name="prescriptionExists"
                      v-model="value.prescriptionExists"
                      label="Has a prescription been written for this order?"
                      :options="['No', 'Yes']"
                      rules="required"
                      required=true
          />
        </Col>
        <Col class="col-auto" v-show="value.prescriptionExists === 'Yes'">
          <div class="alert alert-warning" role="alert">
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
            </svg>
            Please provide a photo/copy of the script in the next section.
          </div>
        </Col>
      </Row>

    </Section>
    <hr v-show="value.prescriptionExists === 'No'">
    <Section title="GP/Prescriber Details"
             text="Please provide details of the GP/Prescriber below and ensure that the prescription request has
                        been sent to the GP/Prescriber upon completion of this form. You can use the notes section below to set a custom message in the email that we will send to the prescriber requesting the prescription."
             v-show="value.prescriptionExists === 'No'"
    >
      <Row>
        <Col class="col-12 col-sm-6 col-md-4" v-show="value.prescriptionExists === 'No'">
          <TextInput name="prescriber.name"
                     v-model="value.prescriber.name"
                     label="GP/Prescriber's Name"
                     rules="required"
                     v-if="value.prescriptionExists === 'No'"
                     required=true
          />
        </Col>
        <Col class="col-12 col-sm-6 col-md-4" v-show="value.prescriptionExists === 'No'">
          <TextInput name="prescriber.phone"
                     v-model="value.prescriber.phone"
                     label="GP/Prescriber's Phone"
                     type="number"
                     v-if="value.prescriptionExists === 'No'"
                     rules="required"
                     required=true
          />
        </Col>
        <Col class="col-12 col-sm-6 col-md-4" v-show="value.prescriptionExists === 'No'">
          <TextInput name="prescriber.email"
                     v-model="value.prescriber.email"
                     label="GP/Prescriber's Email"
                     type="email" rules="required|email"
                     required=true
                     v-if="value.prescriptionExists === 'No'"
          />
        </Col>
        <Col class="col-12" v-show="value.prescriptionExists === 'No'">
          <AddressInput name="prescriber.address"
                        v-model="value.prescriber.address"
                        label="GP/Prescriber's Address"
                        v-if="value.prescriptionExists === 'No'"
                        rules="required"
                        required=true
          />
        </Col>
      </Row>
      <Row v-show="value.prescriptionExists === 'No'">
        <Col>
          <h6 class="form-field-label">Notes for the Prescriber/GP</h6>
          <TextArea name="prescriber.notes"
                    v-model="value.prescriber.notes"
                    v-show="value.prescriptionExists === 'No'"/>
        </Col>
      </Row>
    </Section>
    <hr/>
    <Section title="Upload Documents"
             text="Please upload any documents to assist with the order here: i.e. GP referral letter, made to measure, made to order or ready to wear ordering forms.">
      <Row>
        <Col>
          <FileUpload v-model="value.files" :max-size=maxUploadSize
                      :allowed-extensions=allowedExts></FileUpload>
        </Col>
      </Row>
    </Section>
    <hr/>
    <Section title="Additional Notes"
             text="Please provide any extra information regarding the order, the information submitted in this section will only be sent to Daylong Direct."
    >
      <Row>
        <Col>
          <h6 class="form-field-label">To Daylong Direct</h6>
          <TextArea name="notes" v-model="value.notes"></TextArea>
        </Col>
      </Row>
    </Section>

    <hr/>

    <CheckBox
        name="nominationConfirmation"
        v-model="value.nominationConfirmation"
        label="By submitting the prescription details above, you confirm your consent for Daylong Direct to process the personal data
      in compliance with GDPR regulations. In addition, you agree to nominate Daylong Direct as your
      appliance contractor for the dispensing of all medical appliances."
        rules="checked"
        required
    />

  </div>
</template>

<script>
import {Section, Row, Col} from "@/components/layout";
import {
  TextInput,
  TextArea,
  RadioInput,
  SelectInput,
  AddressInput,
  ProductRepeater,
  FileUpload,
  CheckBox
} from "@/components/input";

export default {
  name: "ForwardOrderStep1",
  components: {
    FileUpload,
    TextInput,
    TextArea,
    RadioInput,
    SelectInput,
    AddressInput,
    ProductRepeater,
    CheckBox,
    Section,
    Row,
    Col
  },
  props: ["value"],
  data() {
    return {
      maxUploadSize: 10485760,
      allowedExts: [
        'png', 'jpeg', 'jpg', 'gif', 'xls', 'xlsx', 'pdf', 'doc', 'docx', 'txt'
      ],
      exemptionReasons: [
        {
          text: 'A. is 60 years of age or over or is under 16 years of age',
          value: 'A'
        },
        {
          text: 'B. is 16, 17 or 18 and in full-time eductation',
          value: 'B'
        },
        {
          text: 'D. Maternity exemption certificate',
          value: 'D'
        },
        {
          text: 'E. Medical exemption certificate',
          value: 'E'
        },
        {
          text: 'F. Prescription prepayment certificate',
          value: 'F'
        },
        {
          text: 'G. Prescription exemption certificate issued by Ministry of Defence',
          value: 'G'
        },
        {
          text: 'L. HC2 (full help) certificate',
          value: 'L'
        },
        {
          text: 'H. Income Support or income-related Employment and Support Allowance',
          value: 'H'
        },
        {
          text: 'K. Income-based Jobseeker\'s Allowance',
          value: 'K'
        },
        {
          text: 'M. Tax Credit exemption certificate',
          value: 'M'
        },
        {
          text: 'S. Pension Credit Guarantee Credit (including partners)',
          value: 'S'
        },
        {
          text: 'U. Universal Credit and meets the criteria',
          value: 'U'
        }
      ]
    }
  }
}
</script>

<style lang="scss">

#step-1 {

  i {
    margin-right: 0.5em;
  }

  .section {

    .card-title {
      color: #00477f;
    }

    .form-field-label {
      color: #3d3f40;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    }
  }
}
</style>
